const obj =  {
    empId:'',
    empName:'',
    memBerId:'',
    email:'',
    emailUniqId:'',
   crmRights:{
    crmDashboard:{
           value:false,
           rights:[]
    },
    crmEmployee:{
           value:false,
           items:{
               crmDashboard1:{
                   value:false,
                  rights:[]
               },
               crmEmployeeTarget1:{
                   value:false,
                   rights:[]
               },
               crmMemberCalls1:{
                   value:false,
                   rights:[]
               },crmSalesCall1:{
                   value:false,
                   rights:[]
               },crmServicesRateCard1:{
                   value:false
               }
           }
    },
    crmTrainer:{
           value:false,
           items:{
               superRight:{
                   dailybatchAttendance:[],
                   monthlyReport:[],
                   clientAttendanceReg:[]
               },    
               crmLiveClasses1:{
                   value:false
               },
               crmAllBatches1:{
                   value:false
               },
               crmPtClasses1:{
                   value:false
               },
               crmTtcClasses:{
                   value:false
               },
               crmAllMembers1:{
                   value:false
               }
           }
    },
    crmLeads:{
        value:false,
        items:{
            superRight:{
                addOn:[],
                delete:[],
                edit:[]
            },
            crmAllEnquiry1:{
                value:false,
            },
            crmAppointment1:{
                value:false,
            },
            crmTrialUpdate1:{
                value:false,
            },
            crmProspects1:{
                value:false,
            },
            crmCallsReports1:{
                value:false,
            },
            crmColdEnquires1:{
                value:false,
            }
        }
    },
    crmCientManagment:{
        value:false,
        items:{
            superRight:{
                delete:[],
                edit:[],
                status:[],
                profile:[]
            },
            crmAllClients1:{
                value:false,
            },
            crmActiveClients1:{
                value:false,
            },
            crmRenewalsClient1:{
                value:false,
            },
            crmRenewedClients1:{
                value:false,
            },
            crmLeftClients1:{
                value:false,
            },
            crmClientSupport1:{
                value:false,
            }
        }
    },
    crmMarketing:{
        value:false,
        items:{
            superRight:{
                addOn:[],
                delete:[],
                edit:[],
                status:[],
            },
            crmEmailMarketing1:{
                value:false
            },
            crmSmsMarketing1:{
                value:false
            },
            crmPushMarketing1:{
                value:false
            },
            crmBulkMailerData1:{
                value:false
            },
            crmBulkCallingData1:{
                value:false
            },
            crmCustomerReview1:{
                value:false
            },
            crmOffersMaster1:{
                value:false
            }
        }
    },
    crmFitness:{
        value:false,
        superRight:{
           addOn:[],
           delete:[],
           edit:[],
           access:[],
       },
       items:{
           crmFitnessGoal:{
               value:false,
               rights:[]
           }
       }
    }
    },
   erpRights:{
     erpTaskList:{
          value:false,
          items:{
              erpTaskListCalender:{
                  value:false,
                  rights:[]
              }
          }
     },
     erpInventory:{
          value:false,
          items:{
              erpStockList:{
                  value:false,
                  rights:[]
              },
              erpStockReport:{
                  value:false,
                  rights:[]
              },
              erpProductList:{
                  value:false,
                  rights:[]
              },
              erpStockAlert:{
                  value:false,
                  rights:[]
              },
              erpProductSalesReport:{
                  value:false,
                  rights:[]
              },
              erpOfficeInventory:{
                  value:false,
                  rights:[]
              },
              erpImpCallList:{
                  value:false,
                  rights:[]
              },
              erpProductInvoice:{
                  value:false,
                  rights:[]
              }
          }
     },
     erpFinance:{
          value:false,
          items:{
              erpInvoices:{
                  value:false,
                  items:{
                      erpTotalInvoice:{
                          value:false,
                          rights:[]
      
                      },
                      erpPaidInvoice:{
                          value:false,
                          rights:[]
                      },
                      erpBalancePayment:{
                          value:false,
                          rights:[]
                      },
                      erpReceipts:{
                          value:false,
                          rights:[]
                      },
                      erpCancelledInvoice:{
                          value:false,
                          rights:[]
                      },
                      erpCommentsOfWrittenOffInvoice:{
                          value:false,
                          rights:[]
                      }
                      
                  }
                  
              },
              erpRevenues:{
              value:false,
              items:{
                  erpRevenueDetails:{
                      value:false,
                      rights:[]
                  },
                  erpServicesWiseRevenue:{
                      value:false,
                      rights:[]
      
                  },
                  erpNewClientRevenue:{
                      value:false,
                      rights:[]
                  },
                  erpRenewalsRevenue:{
                      value:false,
                      rights:[]
      
                  },
                  erpLeadReport:{
                      value:false,
                      rights:[]
      
                  },
                  erpRevenueReport:{
                      value:false,
                      rights:[]
                  }
              }
              },
              erpCollectionReport:{
                  value:false,
                  items:{
                      erpTotalCollection:{
                       value:false,
                       rights:[]
                      },
                      erpPaymentMode:{
                       value:false,
                       rights:[]
                      },
                      erpCashReport:{
                       value:false,
                       rights:[]
                      },
                      erpChequeReport:{
                       value:false,
                       rights:[]
                      }
                  }
              },
              erpExpense:{
               value:false,
               items:{
                  erpCenterExpense:{
                      value:false,
                      rights:[]
                  },
                  erpDailyExpense:{
                      value:false,
                      rights:[]
                  },
                  erpPettyCash:{
                      value:false,
                      rights:[]
                  }
               }     
              },
              erpSales:{
               value:false,
               items:{
                  erpDsrReport:{
                      value:false,
                      rights:[]
                  },
                  erpTargetVsAchievment:{
                      value:false,
                      rights:[]
                  }
               }
              } 
      
          }
     },
     erpHrManagement:{
          value:false,
          items:{
              erpRecuritment:{
                  value:false,
                  rights:[]
              },
              empLoyeeHrProfile:{
                  value:false,
                  items:{
                      erpEmployeeProfile:{
                          value:false,
                          rights:[]
                      },
                      erpEmployeeDocuments:{
                          value:false,  
                          rights:[]
                      },
                      erpJobProfile:{
                          value:false,   
                          rights:[]  
                      }
                  }
              },
              erpHrTargetSheet:{
                  value:false,
                  items:{
                      erpTargetSheet:{
                          value:false,
                          rights:[]
      
                      },
                      erpEmpPerformance:{
                          value:false,
                          rights:[]
                      }
                  }
              },
              erpEmpAttendess:{
                value:false,
                items:{
                  erpEmpCheckIns:{
                      value:false,
                      rights:[]
                  },
                  erpBiometricEmp:{
                      value:false,
                      rights:[]
                  },
                  erpEmpAttedanceRegister:{
                      value:false,
                      rights:[]
                  }
                }
         
              },
              erpHrHrPolicy:{
                  value:false,
                  items:{
                      erpHrPolicy:{
                          value:false,
                          rights:[]
                      },
                      erpHolidayList:{
                          value:false,
                          rights:[]
                      },
                      erpShiftTiming:{
                          value:false,
                          rights:[]  
                      },
                      erpEmpJoing:{
                          value:false,   
                          rights:[] 
                      }  
                  }
              },
              erpSalarySheet:{
                  value:false,
                  items:{
                      erpLeaveSetup:{
                          value:false,
                          rights:[]
                      },
                      erpEmpSalarySheet:{
                          value:false,
                          rights:[]
                      },
                      erpTrainerSalarySlip:{
                          value:false,
                          rights:[]
                      },
                      erpAllTrainerReport:{
                          value:false,
                          rights:[]
                      }
                  }
              },
              erpAllRights:{
                  value:false,
                  rights:[]
              },
          }
     },
     erpCourse:{
          eximpRights:[],
          value:false,
          items:{
              erpTTCClients:{
               value:false,
               rights:[]
              },
              erpTTCVideos:{
               value:false,
               rights:[]
              },
              erpTTCPdf:{
               value:false,
               rights:[]
              },
              erpCourseCompletion:{
               value:false,
               rights:[]
              }
          }
      
      }
    },
   masterRights:{
    masterCenterSetup:{
            value:false,
            items:{
                masterCompanyLogoSetup:{
                    value:false,
                    rights:[]
                },
                masterCompanyProfileSetup:{
                    value:false,
                    rights:[]  
                },
                masterServicesMaster:{
                    value:false,
                    rights:[]  
                },
                masterPackageMaster:{
                    value:false,
                    rights:[]  
                },
                masterBatchTimeMaster:{
                    value:false,
                    rights:[] 
                },
                masterFormMaster:{
                    value:false,
                    rights:[] 
                },
                masterInvoiceMaster:{
                    value:false,
                    rights:[] 
                }
    
            }
    },
    masterClientFeedback:{
           value:false,
           rights:[]      
    },
    masterMarketing:{
            value:false,
            items:{
                masterLeadSourseMaster:{
                    value:false,
                    rights:[]       
                },
                masterSmsEmailTemp:{
                    value:false,
                    rights:[]     
                },
                masterGallertyMaster:{
                    value:false,
                    rights:[]    
                },
                masterAutomatedComToStaff:{
                    value:false,
                    rights:[]     
                }
            }
    },
    masterClient:{
            value:false,
            items:{
          masterClientTransferMaster:{
            value:false,
            rights:[]      
          }
        }   
    },
    masterHr:{
            value:false,
            items:{
                masterEmployeeDesignation:{
                 value:false,
                 rights:[]    
                },
                masterHrPolicy:{
                 value:false,
                 rights:[]   
                },
                masterHolidaysList:{
                    value:false,
                    rights:[]     
                },
                masterEmpJoining:{
                    value:false,
                    rights:[]    
                },
                masterJobProfile:{
                    value:false,
                    rights:[]     
                },
                masterEmployeeDocument:{
                    value:false,
                    rights:[] 
                },
                masterLeaveSetup:{
                    value:false,
                    rights:[]  
                },
                masterSalarySheet:{
                    value:false,
                    rights:[] 
                },
                masterShiftTiming:{
                    value:false,
                    rights:[] 
                },
                masterTrainerSalarySlip:{
                    value:false,
                    rights:[]    
                },
                masterEmpPrformance:{
                    value:false,
                    rights:[]  
                }
            } 
    },
    masterInverntory:{
            value:false,
            items:{
                masterAllProductListingMaster:{
                    value:false,
                    rights:[]  

                },
                masterOfficeInventory:{
                    value:false,
                    rights:[]  
                }
            } 
    },
    masterFinance:{
            value:false,
            items:{
                masterExpnessCategor:{
                    value:false,
                    rights:[]
                },
                masterBudgeting:{
                    value:false,
                    rights:[]
                },
                masterInvoiceSetupMaster:{
                    value:false,
                    rights:[] 
                },
                masterTaxSetupMaster:{
                    value:false,
                    rights:[]  
                }
            }
    },
    masterCenterPartners:{
            value:false,
            rights:[]
    }
   }   
   }

export default obj